import React, { useEffect } from 'react'
import HeroContent from '../Hero_component/Hero';
import DressComp from '../DressComp/DressComp';

const Dress = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component loads
  }, []);
  return (
    <>
       <HeroContent
        title="Dress Desining"
        image={require("../../resource/Banner/branch.jpeg")}
      />
      <DressComp />
    </>
  )
}

export default Dress;
